import api from '../../lib/api';
import { url_api_v1_downgrade_reason_post, url_api_v1_groups_get, url_api_v1_profiles_show_get, url_api_v1_user_favorites_get, url_api_v1_user_favorites_users_get, url_api_v1_user_group_get, url_api_v1_user_plan_cancel, url_api_v1_user_plans, url_api_v1_user_plans_contact_sale_post, url_api_v1_users_directory_all_get, url_api_v1_users_imdb_post, url_api_v1_users_profile_get, url_api_v1_users_search_get, url_states_get } from '../../lib/apiUrl';
import { MasterPlan } from '../user_plans/UserPlanModal';

class UserService {
  getUsers = async (pageParam: number, perPage: number, filterParams: any, sortMode: any) => {
    try {
      let url = url_api_v1_users_search_get;
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage;
      if (filterParams.firstName && filterParams.firstName.length > 0) {
        filterParams.firstName;
        queryFilter += (queryFilter == '' ? '?' : '&') + 'first_name=' + filterParams.firstName;
      }
      if (filterParams.lastName && filterParams.lastName.length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'last_name=' + filterParams.lastName;
      }
      if (filterParams.keyword && filterParams.keyword.trim().length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'keyword=' + filterParams.keyword.trim();
      }

      if (filterParams.selectedCountries && filterParams.selectedCountries.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'countries=' + filterParams.selectedCountries.join(',');
      }
      if (filterParams.selectedState) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'state=' + filterParams.selectedState;
      }
      if (filterParams.selectedEthnicities && filterParams.selectedEthnicities.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'ethnicities=' + filterParams.selectedEthnicities.join(',');
      }

      if (
        filterParams.heightRange &&
        filterParams.heightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'heightRange=' + filterParams.heightRange.join(',');
      }

      if (
        filterParams.weightRange &&
        filterParams.weightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'weightRange=' + filterParams.weightRange.join(',');
      }

      if (filterParams.selectedGenders && filterParams.selectedGenders.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'genders=' + filterParams.selectedGenders.join(',');
      }
      if (filterParams.onlyfav) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'onlyfav=1';
      } else if (filterParams.selectedUserGroups && filterParams.selectedUserGroups.length > 0) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'usergroups=' + filterParams.selectedUserGroups.join(',');
      }
      if (filterParams.selectedSpecialtySkills && filterParams.selectedSpecialtySkills.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'skills=' + filterParams.selectedSpecialtySkills.join(',');
      }

      if (filterParams.exclude_collection_id) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'exclude_collection_id=' + filterParams.exclude_collection_id;
      }

      if (sortMode != '') {
        queryFilter += (queryFilter == '' ? '?' : '&') + `sort=${sortMode.trim()}`;
      }
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  getUserDirectoryAll = async (pageParam: number, perPage: number, filterParams: any, sortMode: any) => {
    try {
      let url = url_api_v1_users_directory_all_get;
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage;
      if (filterParams.firstName && filterParams.firstName.length > 0) {
        filterParams.firstName;
        queryFilter += (queryFilter == '' ? '?' : '&') + 'first_name=' + filterParams.firstName;
      }
      if (filterParams.lastName && filterParams.lastName.length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'last_name=' + filterParams.lastName;
      }
      if (filterParams.keyword && filterParams.keyword.trim().length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'keyword=' + filterParams.keyword.trim();
      }

      if (filterParams.selectedCountries && filterParams.selectedCountries.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'countries=' + filterParams.selectedCountries.join(',');
      }
      if (filterParams.selectedState) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'state=' + filterParams.selectedState;
      }
      if (filterParams.selectedEthnicities && filterParams.selectedEthnicities.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'ethnicities=' + filterParams.selectedEthnicities.join(',');
      }

      if (
        filterParams.heightRange &&
        filterParams.heightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'heightRange=' + filterParams.heightRange.join(',');
      }

      if (
        filterParams.weightRange &&
        filterParams.weightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'weightRange=' + filterParams.weightRange.join(',');
      }

      if (filterParams.selectedGenders && filterParams.selectedGenders.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'genders=' + filterParams.selectedGenders.join(',');
      }
      if (sortMode != '') {
        queryFilter += (queryFilter == '' ? '?' : '&') + `sort=${sortMode.trim()}`;
      }
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  getFavorites = async (pageParam: number, perPage: number) => {
    try {
      let url = url_api_v1_user_favorites_get;
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage;
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getFavoriteUsers = async (pageParam: number, perPage: number, filterParams: any, sortMode: string) => {
    try {
      let url = url_api_v1_user_favorites_users_get;
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage;
      if (filterParams.firstName && filterParams.firstName.length > 0) {
        filterParams.firstName;
        queryFilter += (queryFilter == '' ? '?' : '&') + 'first_name=' + filterParams.firstName;
      }
      if (filterParams.lastName && filterParams.lastName.length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'last_name=' + filterParams.lastName;
      }
      if (filterParams.keyword && filterParams.keyword.trim().length > 0) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'keyword=' + filterParams.keyword.trim();
      }

      if (filterParams.selectedCountries && filterParams.selectedCountries.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'countries=' + filterParams.selectedCountries.join(',');
      }
      if (filterParams.selectedState) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'state=' + filterParams.selectedState;
      }
      if (filterParams.selectedEthnicities && filterParams.selectedEthnicities.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'ethnicities=' + filterParams.selectedEthnicities.join(',');
      }

      if (
        filterParams.heightRange &&
        filterParams.heightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'heightRange=' + filterParams.heightRange.join(',');
      }

      if (
        filterParams.weightRange &&
        filterParams.weightRange.length >= 2
      ) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'weightRange=' + filterParams.weightRange.join(',');
      }

      if (filterParams.selectedGenders && filterParams.selectedGenders.length) {
        queryFilter +=
          (queryFilter == '' ? '?' : '&') + 'genders=' + filterParams.selectedGenders.join(',');
      }
      if (sortMode != '') {
        queryFilter += (queryFilter == '' ? '?' : '&') + `sort=${sortMode.trim()}`;
      }
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getStates = async (country: string) => {
    try {
      const response = await api.get(url_states_get + '?country=' + country);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting states.');
      }
      return Object.entries(response.data || {}).map(([id, name]) => ({ id, name: name as string }));
    } catch (error) {
      throw error;
    }
  };
  getGroups = async (pageParam: number, perPage: number) => {
    try {
      let url = url_api_v1_user_group_get;
      let queryFilter = '?page=' + pageParam + '&per_page=' + perPage;
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getGroupDetails = async (collectionId:number) => {
    try {
      let url = url_api_v1_groups_get.replace(':group_id', collectionId.toString());
      let queryFilter = '';
      console.log('url', url);
      const response = await api.get(url + queryFilter, {
          headers: {
            'Accept': 'application/json'
          }
        });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data || response;
    } catch (error) {
      throw error;
    }
  };
  cancelSubscription = async (subscription_tier: string, billing_cycle: string) => {
    try {
      let url = url_api_v1_user_plan_cancel;
      let filterUrl = '';
      if (subscription_tier && subscription_tier.length > 0) {
        filterUrl += (filterUrl == '' ? '?' : '&') + 'subscription_tier=' + subscription_tier;
      }
      if (billing_cycle && billing_cycle.length > 0) {
        filterUrl += (filterUrl == '' ? '?' : '&') + 'billing_cycle=' + billing_cycle;
      }
      const response = await api.get(url + filterUrl);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while cancelling subscription.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };

  getUserPlans = async () => {
    try {
      let url = url_api_v1_user_plans;
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting subscription.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  contactSalePost = async (note: string, masterPlan: MasterPlan) => {
    try {
      let url = url_api_v1_user_plans_contact_sale_post;

      const payload = {
        note: note,
        stripe_product_id: masterPlan.stripe_product_id,
        subscription_tier: masterPlan.subscription_tier,
        plan_name: masterPlan.plan_name,
        billing_cycle: masterPlan.billing_cycle,
      };
      let filter = '';
      const response = await api.post(url + filter, payload);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while cancelling subscription.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  imdbUrlPost = async (imdburl: string) => {
    try {
      let url = url_api_v1_users_imdb_post;

      const payload = {
        imdburl: imdburl
      };
      let filter = '';
      const response = await api.post(url + filter, payload);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while setting IMDB Url.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };

  getUserProfile = async (userUuid: string, project_id: string, project_folder_id: string) => {
    try {
      const url = url_api_v1_users_profile_get.replace(':uuid', userUuid);
      let queryFilter = '';
      if (project_id) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'project_id=' + project_id;
      }
      if (project_folder_id) {
        queryFilter += (queryFilter == '' ? '?' : '&') + 'project_folder_id=' + project_folder_id;
      }
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting user profile.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  getPublicProfile = async (slugOrId: string) => {
    try {
      const url = url_api_v1_profiles_show_get.replace(':id', slugOrId);
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while getting public profile.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  toggleFavorite = async (userUuid: string, setFav: boolean) => {
      // const isFavoritedIndex = favoritesUsers.findIndex((item) => item.uuid == userUuid);
      // const isFavorited = isFavoritedIndex >= 0;
      // const isFavorited = false;
      const method = !setFav ? 'DELETE' : 'POST';
      const url = !setFav ? `/api/v1/favorites/${userUuid}` : '/api/v1/favorites';
  
      try {
        if(setFav) {
          let queryFilter = '';
          const payload = {
            member_uuid: userUuid
          };
          const response = await api.post(url + queryFilter, payload);
          if (response.status !== 200 && response.status !== 201) {
            throw new Error('Error while getting user profile.');
          }
        return response.data;
        } else {
          let queryFilter = '';
          const payload = {
            member_uuid: userUuid
          };
          const response = await api.delete(url + queryFilter);
          if (response.status !== 200 && response.status !== 201) {
            throw new Error('Error while getting user profile.');
          }
        return response.data;
        }
      } catch (error) {
        console.error('Error toggling favorite:', error);
        throw error;
      }
      return null;
    }
  downgradeReasonPost = async (reason1: string, reason2: string, from_plan: string, to_plan: string) => {
    try {
      let url = url_api_v1_downgrade_reason_post;

      const payload = {
          reason1: reason1,
          reason2: reason2,
          from_plan: from_plan,
          to_plan: to_plan
      };
      let filter = '';
      const response = await api.post(url + filter, payload);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error adding reason.');
      }
      return true;
    } catch (error) {
      console.log(error);
      // throw error;
    }
  };
  
}

const userService = new UserService();

export default userService;
